import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootReducerType } from "@store/store";
import { useNavigate } from "react-router-dom";
import Header from "@components/Header/Header";
import CommonLoginHeader from "@components/Header/CommonLoginHeader";
import ChatbotWidget from "@modules/chatbotwidget";

const PublicRoute = () => {
  const { userLogginedIn } = useSelector(
    (state: RootReducerType) => state.login
  );
  const navigate = useNavigate();
  const location = useLocation();
  // React.useEffect(() => {
  //     if (userLogginedIn) {
  //         navigate("/application-dashboard");
  //     }
  // }, [])
  React.useEffect(() => {
    if (userLogginedIn) navigate("/application-dashboard");
  }, [userLogginedIn, navigate]);
  const COMMON_LOGIN_PATHS = [
    "/common-login",
    "/access-permission",
    "/right-of-way-permission",
    "/public-comments",
    "/guidelines"
  ];

  // const useCommonLoginHeader = COMMON_LOGIN_PATHS.includes(location.pathname);
  const useCommonLoginHeader = COMMON_LOGIN_PATHS.some(p =>
    location.pathname.startsWith(p)
  );

  return (
    <>
      {/* <Header /> */}
      {/* {useCommonLoginHeader ? <CommonLoginHeader /> : <Header />} */}
      {useCommonLoginHeader ? <CommonLoginHeader /> : <CommonLoginHeader />}
      <Outlet />
      <ChatbotWidget />
      
    </>
  );
};

export default PublicRoute;
